import { useTranslation } from 'react-i18next'

import EntityList from 'js/components/EntityList/EntityList'
import FileListItem from 'js/components/FileListItem'
import { H4 } from 'js/components/Heading'

import styles from './Attachments.module.css'

type Props = {
    attachments: any[]
}

const Attachments = ({ attachments }: Props) => {
    const { t } = useTranslation()

    if (!attachments || attachments.length === 0) {
        return null
    }

    return (
        <div className={styles.wrapper}>
            <H4>{t('global.attachments')}</H4>
            <EntityList as="ul" $showBorder>
                {attachments.map((file) => {
                    return (
                        <li key={`${file.guid}-file`}>
                            <FileListItem entity={file} showDownload={true} />
                        </li>
                    )
                })}
            </EntityList>
        </div>
    )
}

export default Attachments
